import React, { useMemo, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import CutSceneFlipBook from "./CutSceneFlipBook";
import arc1Act1CutScene from "../../data/storyMode/arc-1/act-1";
import arc1Act2CutScene from "../../data/storyMode/arc-1/act-2";

export default function StoryModeTestUI() {
  const [selectedCutsceneId, setSelectedCutsceneId] = useState("arc-1-act-2");
  const [isCutSceneComplete, setIsCutSceneComplete] = useState(false);
  const selectedCutscene = useMemo(() => {
    if (selectedCutsceneId === arc1Act1CutScene.id) return arc1Act1CutScene;
    return arc1Act2CutScene;
  }, [selectedCutsceneId]);

  return (
    <Box
      sx={{
        height: "100dvh",
        width: "100dvw",
        color: "#fff",
        overflow: "hidden",
        position: "relative",
        background:
          "radial-gradient(circle at top, rgba(55, 98, 255, 0.25), transparent 30%), linear-gradient(180deg, #050816 0%, #090f1f 48%, #04070f 100%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "36px 36px",
          opacity: 0.22,
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 10,
          width: 240,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid rgba(255,255,255,0.12)",
          bgcolor: "rgba(5, 8, 22, 0.82)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Typography sx={{ mb: 1, fontSize: 12, fontWeight: 800, color: "#e2e8f0" }}>
          Test cutscene
        </Typography>
        <FormControl fullWidth size="small">
          <InputLabel
            id="story-mode-test-cutscene-label"
            sx={{ color: "#cbd5e1" }}
          >
            Cutscene
          </InputLabel>
          <Select
            labelId="story-mode-test-cutscene-label"
            value={selectedCutsceneId}
            label="Cutscene"
            onChange={(event) => {
              setSelectedCutsceneId(event.target.value);
              setIsCutSceneComplete(false);
            }}
            sx={{
              color: "#f8fafc",
              "& .MuiSelect-icon": {
                color: "#cbd5e1",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(255,255,255,0.18)",
              },
            }}
          >
            <MenuItem value={arc1Act1CutScene.id}>Arc 1 Act 1</MenuItem>
            <MenuItem value={arc1Act2CutScene.id}>Arc 1 Act 2</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {!isCutSceneComplete ? (
        <CutSceneFlipBook
          key={selectedCutscene.id}
          cover={selectedCutscene.cover}
          pages={selectedCutscene.pages}
          continuePage={selectedCutscene.continuePage}
          initialPage={0}
          showPageMeta={false}
          showPanelText
          showStatus={false}
          onCutSceneComplete={() => setIsCutSceneComplete(true)}
        />
      ) : (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "#000",
          }}
        />
      )}
    </Box>
  );
}
